import { Component } from '@angular/core';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-about-our-story',
  imports: [TranslatePipe],
  templateUrl: './about-our-story.html',
  styleUrl: './about-our-story.scss',
})
export class AboutOurStory {}
